import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import styles from './center-layout.scss'

export default class CenterLayout extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
  }

  static defaultProps = {
    children: null,
  }

  render() {
    return (
      <div className={ styles['container'] }>{ this.props.children }</div>
    )
  }
}
